import React from 'react';
import { BACKEND_BASE_URL } from '../../../../../config';
import { guideType, maxBasedBrokerId } from '../../../../constants';
import {
  QuotationCardStyles, LeftCol, LogoContainer, LogoPriceContainer, PriceContainer, QuoteInformationContainer, QuoteInformationItem, RightCol, Price,
} from '../../../redesignComponents/ResultPageComponents/v2/QuotationCard.styles';

function PreventivassCardNoAquista({ quotation, requestInfo }) {
  return (
    <QuotationCardStyles>
      <LeftCol>
        <div>
          {quotation.preventivas_company_quality
            && (
              <div className={`badge mb-2 ${quotation.preventivas_company_quality.color === 'green' ? 'bg-success' : quotation.preventivas_company_quality.color === 'yellow' ? 'bg-warning' : 'bg-danger'}`}>
                Indice Di Qualità:
                {' '}
                <b className="fs-6">{parseFloat(quotation.preventivas_company_quality.coefficiente).toFixed(2)}</b>
              </div>
            )}
          <LogoPriceContainer>
            <LogoContainer>
              <img src={`${BACKEND_BASE_URL}/preventivass/companies/${quotation.logo_filename}`} alt={`${quotation.company_name} Logo`} />
            </LogoContainer>
            <QuoteInformationItem>
              <h6>Compagnia:</h6>
              <p>{quotation.company_name}</p>
            </QuoteInformationItem>
          </LogoPriceContainer>
        </div>
      </LeftCol>
      <RightCol>
        <div>
          <QuoteInformationContainer>
            <QuoteInformationItem>
              <h6>
                Guida:
              </h6>
              <p>
                {guideType.find((v) => v.id === requestInfo.guide_type).name}
              </p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>
                Risarcimento:
              </h6>
              <p>
                Rc con
                {' '}
                <b>Risarcimento</b>
                {' '}
                <br />
                {' '}
                <b>Diretto</b>
                {' '}
                e
                {' '}
                <b>RFS</b>
              </p>
            </QuoteInformationItem>
            <QuoteInformationItem>
              <h6>
                Massimale:
              </h6>
              <p>
                <b>
                  {maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][0] : "6'450'000"}
                  &euro;
                </b>
                {' '}
                Danni a persone
                <br />
                <b>{maxBasedBrokerId[requestInfo.broker_agent_id] ? maxBasedBrokerId[requestInfo.broker_agent_id][0] : "1'050'000"}</b>
                {' '}
                Danni a cose
              </p>
            </QuoteInformationItem>
          </QuoteInformationContainer>
        </div>
        <PriceContainer>
          <Price>
            <h5>
              Prezzo annuo:
            </h5>
            <h2>
              &euro;
              {Number(quotation.amount).toLocaleString('it-IT', {
                minimumFractionDigits: 2,
              })}
            </h2>
          </Price>
        </PriceContainer>
      </RightCol>
    </QuotationCardStyles>
  );
}

export default PreventivassCardNoAquista;
